import React from 'react';
import './Clientes-Modal.css';
//import CasaArmp4 from './assets/Palacio/CasaAr.mp4';
import palacio from './assets/Palacio/palacio.mp4';

const CasaArzobispal = () => {
  return (
    <div className="container">
      <h2>✅ Proyecto: Palacio Arzobispal de Pamplona 🌞✨</h2>

 <video controls>
        <source src={palacio} type="video/mp4" />
        Tu navegador no soporta la reproducción de video.
      </video>

      <p>        <span className="highlight">Un referente espiritual que ahora también es un referente ambiental:
          energía limpia al servicio de la fe y la sostenibilidad. <br/>
        </span> <br/>
        En el Palacio Arzobispal de Pamplona ubicado en el corazón de la ciudad
        y considerado un símbolo de la vida religiosa local instalamos un
        sistema solar fotovoltaico conectado a la red con una capacidad de 19.95
        kWp, compuesto por 30 paneles solares de alta eficiencia y un inversor
        multicanal de 20 kW.<br/><br/> Esta tecnología permite gestionar de manera segura
        y estable las cargas eléctricas del lugar, optimizando el rendimiento
        del sistema y garantizando energía continua para sus actividades
        diarias.
        <br />
        <br />
        Los objetivos de este proyecto fueron:<br/>
        <br/> ✔ Reducir los costos asociados
        al consumo eléctrico del Palacio <br/>✔ Implementar una solución sostenible
        en coherencia con el cuidado del medio ambiente <br/>✔ Garantizar energía
        constante para iluminación y equipos de uso frecuente en este edificio
        institucional<br/><br/> Hoy, el Palacio Arzobispal genera parte importante de su
        propia energía limpia, disminuyendo mensualmente los costos de
        facturación eléctrica y contribuyendo al medio ambiente.<br/><br/> Con esta
        instalación, el Palacio no solo cumple con su compromiso espiritual,
        sino también con su compromiso ambiental, convirtiéndose en un ejemplo
        de liderazgo y responsabilidad para la comunidad.<br/>
        <br/>
         <span className="highlight"> Este proyecto cuenta
        con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:<br/><br/></span> 🔧
        Soporte técnico y mantenimiento preventivo <br/>🔧 Monitoreo del sistema para
        garantizar máxima eficiencia energética <br/>🔧 Instalación estructural
        segura y diseñada para prolongar la vida útil del sistema <br/>🔧
        Capacitación al usuario en el manejo de la aplicación de monitoreo <br/>🔧
        Acompañamiento presencial de nuestros ingenieros durante y después de la
        instalación 
        <br/> <br/>   <span className="highlight">
        Una decisión inteligente que une sostenibilidad, ahorro y
     
        propósito en la fe </span>
      </p>
     

            <div className="video-responsive">
        <iframe
          src="https://www.youtube.com/embed/ppdeYrVXvqc"
          title="Testimmonio Palacio Arzobispal"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default CasaArzobispal;
